import { Directive, input, TemplateRef } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[action-option]',
})
export class ActionOptionDirective {
    name = input.required<string>({ alias: 'action-option' });

    constructor(public template: TemplateRef<any>) {}
}
